"use client";

import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToCreate() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const handleJoinClick = () => {
    const targetSection = document.getElementById('join-the-beta-movement');
    if (targetSection) {
      targetSection.scrollIntoView({
        behavior: 'smooth'
      });
      setTimeout(() => {
        const event = new CustomEvent('open-beta-modal');
        window.dispatchEvent(event);
      }, 800);
    }
  };
  const marqueeItems = ["BETA ACCESS", "ANIMATION TOOLS", "STORYBOARDING", "FILM PRODUCTION", "BETA ACCESS", "ANIMATION TOOLS", "STORYBOARDING", "FILM PRODUCTION"];
  return <section data-section-id="3690" id="ready-to-create" className="bg-background text-foreground">
      <div ref={ref} className="relative w-full border-y border-border" style={{
      backgroundColor: "#00F6FF"
    }}>
        <div className={`mx-auto flex min-h-[480px] max-w-7xl flex-col items-start gap-10 px-6 py-16 transition-all duration-700 ease-out md:px-12 lg:flex-row lg:items-center lg:gap-8 lg:py-20 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="w-full lg:w-[65%]">
            <div className="font-default text-xs font-medium tracking-[0.2em] uppercase mb-8" style={{
            color: "hsl(224 71% 4%)"
          }}>
              § 06 — BETA RELEASE
            </div>

            <h2 className="font-default font-extrabold leading-[0.92] tracking-tight" style={{
            color: "hsl(224 71% 4%)",
            fontSize: "clamp(3.5rem, 7vw, 7rem)",
            letterSpacing: "-0.02em"
          }}>
              <span className="block">CREATE YOUR</span>
              <span className="inline-flex items-end gap-3">
                OWN FILMS
                <span aria-hidden="true" className="inline-block" style={{
                backgroundColor: "hsl(224 71% 4%)",
                width: "clamp(0.6rem, 1.2vw, 1.2rem)",
                height: "clamp(0.6rem, 1.2vw, 1.2rem)",
                marginBottom: "clamp(0.4rem, 0.9vw, 0.9rem)"
              }} />
              </span>
            </h2>

            <p className="font-default italic mt-8 max-w-xl" style={{
            color: "hsl(224 71% 4%)",
            fontSize: "20px",
            lineHeight: 1.4
          }}>
              Join the Ruchnii Studios waiting list for exclusive early access to our animation suite.
            </p>
          </div>

          <div className="w-full lg:w-[35%] flex flex-col items-start lg:items-end gap-6">
            <Button onClick={handleJoinClick} size="lg" className="h-auto px-8 py-6 font-default text-sm font-bold uppercase tracking-[0.15em] shadow-2xl hover:shadow-3xl transition-shadow" style={{
            backgroundColor: "hsl(224 71% 4%)",
            color: "#00F6FF",
            borderRadius: 0
          }}>
              JOIN WAITING LIST
              <ArrowRight className="ml-2 size-4" strokeWidth={2.5} />
            </Button>

            <div className="font-default text-xs font-medium tracking-[0.15em]" style={{
            color: "hsl(224 71% 4%)"
          }}>OR EMAIL · RUCHNII@RUCHNII.COM</div>
          </div>
        </div>

        <div className="relative w-full overflow-hidden border-t border-border" style={{
        backgroundColor: "hsl(224 71% 4%)"
      }}>
          <div className="flex whitespace-nowrap animate-[oasis-marquee_40s_linear_infinite]">
            {[...marqueeItems, ...marqueeItems].map((item, i) => <div key={i} data-index={i} className="flex items-center font-default text-xs font-medium tracking-[0.2em] py-3 px-6 uppercase" style={{
            color: "#00F6FF"
          }}>
                <span>{item}</span>
                <span className="mx-6" aria-hidden="true">
                  ·
                </span>
              </div>)}
          </div>
        </div>

        <style>{`
          @keyframes oasis-marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>
    </section>;
}